"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTypographyOverrides = function (theme // eslint-disable-line @typescript-eslint/no-unused-vars
) { return ({
    gutterBottom: {
        marginBottom: "1em",
    },
}); };
//# sourceMappingURL=MuiTypography.js.map